import { createGetApi, createPostApi } from 'friday-async';

class Apis {
  public list = createGetApi<void>({
    url: '/smsTemplate/list',
  });

  public create = createPostApi<{
    templateId: string;
    name: string;
  }>({
    url: '/smsTemplate/create',
  });

  public update = createPostApi<{
    _id: string;
    templateId: string;
    name: string;
  }>({
    url: '/smsTemplate/update',
  });

  public remove = createPostApi<{_id: string}>({
    url: '/smsTemplate/remove',
  });
}

export default Apis;
